import $ from 'jquery'
import Awesomplete from 'awesomplete'

function init () {
  $('.suggestion-module').each(function () {
    inputHandler($(this))
  })
}

function inputHandler (container) {
  let dropdownId = container.data('dropdown-id'),
    dropdown = $('#' + dropdownId),
    inputfiledId = container.data('input-id'),
    inputfield = $('#' + inputfiledId),
    button = container.find('.suggestion-btn'),
    loopPrevent = false,
    recommendations = getAutoCompleteList(),
    searchFieldButton = container.find('.search-icon')

  dropdown.on('change', function () {
    if (!loopPrevent) {
      loopPrevent = true
      inputfield.trigger('reset')
      loopPrevent = false
    }
    loopPrevent = false
    button.trigger('click')
  })

  inputfield.on('keyup', function (e) {
    if (e.keyCode == 13) {
      button.trigger('click')
    }
    if (!loopPrevent) {
      loopPrevent = true
      dropdown.trigger('reset')
      loopPrevent = false
    }
    loopPrevent = false
  })

  button.on('click', () => {
    let dropdownValue = dropdown.val(),
      inputValue = inputfield.val()

    if (dropdownValue !== '') {
      gotoUrl(dropdownValue)
    } else if (inputValue !== '') {
      search(inputValue, container)
    }
  })

  searchFieldButton.on('click', () => {
    let dropdownValue = dropdown.val(),
      inputValue = inputfield.val()

    if (dropdownValue !== '') {
      gotoUrl(dropdownValue)
    } else if (inputValue !== '') {
      search(inputValue, container)
    }
  })

  new Awesomplete(inputfield.get(0), {
    list: recommendations,
    minChars: 3
  })

  inputfield.on('awesomplete-open', function () {
    if (!inputfield.find('.awesomplete-before').length) {
      inputfield.append(
        '<div class=\'awesomplete-before\'>' + window.awesomplete.searchResult + '</div>'
      )
    }
  })
    .on('awesomplete-select', function (event) {
      search(event.originalEvent.text.label, container)
    })

  inputfield.on('awesomplete-close', function () {
    inputfield.find('.awesomplete-before').remove()
  })
}

function getAutoCompleteList () {
  if (window.searchRecommendationsList && window.searchRecommendationsList.length) {
    return window.searchRecommendationsList
  }
  return []
}

function gotoUrl (url) {
  if (isExternal(url)) {
    window.open(url, '_blank')
  } else {
    if (url.indexOf('#') > -1) {
      let urlWithoutHash,
        anchorLink;

      [urlWithoutHash, anchorLink] = url.split('#')

      if (window.location.href == urlWithoutHash) {
        //console.log("setting hash to", anchorLink);
        //e.preventDefault();
        var el = $('#_' + anchorLink)
        if (el.length > 0) {
          $('html, body').animate({
            scrollTop: el.offset().top - 150
          }, 1000, 'linear')
        }
        return false
      } else {
        window.location.href = url
      }
    } else {
      window.location.href = url
    }
  }
}

function search (searchTerm, container) {
  let targetUrl = container.data('url') + '?query=' + encodeURI(searchTerm)
  window.location.href = targetUrl
}

function isExternal (link) {
  let windowLocationHost = window.location.host

  return (link.indexOf(windowLocationHost) === -1)
}

export default {
  init
}
